import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/accessories'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'
import { LoyaltyPointsGraphContainer } from '@grandvisionhq/www-next/slot-components/LoyaltyPointsGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'

const slots: Props['slots'] = {
  BeforeUsps: LoyaltyPointsGraphContainer,
  DynamicDeliveryIndicator: FullDateDeliveryIndicatorContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => (
  <Page {...props} slots={slots} maxOrderableQuantity={cartSettings.maximumQuantity} />
)

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
